import type { ButtonBorderStyle } from '@core/types'

export const borderRadiusSettings: Record<ButtonBorderStyle, number> = {
  default: 4,
  rounded: 30,
  hard: 0,
}

export const heightSettings = {
  small: 25,
  default: 36,
}

export const fontSettings = {
  small: 12,
  default: 16,
}

export type ButtonSize = 'small' | 'default'
export type ButtonVariant = 'primary' | 'outlined'
export interface BaseButtonProps {
  borderStyle?: ButtonBorderStyle
  disabled?: boolean
  ripple?: boolean
  variant?: ButtonVariant
  size?: ButtonSize
  icon?: React.ReactNode
  block?: boolean
  isLoading?: boolean
}

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  BaseButtonProps

// Require href for AnchorButton
export type AnchorButtonProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  BaseButtonProps & {
    href: string
  }
